import { render, staticRenderFns } from "./logininpage.vue?vue&type=template&id=78d510c8&scoped=true&"
import script from "./logininpage.vue?vue&type=script&lang=js&"
export * from "./logininpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d510c8",
  null
  
)

export default component.exports